import { body, navbar } from "../elements";
import { getNavbarHeight } from "./elHeights";

export function useBodySetUp() {
  if (!navbar) return;

  function setNavbarHeight() {
    body.style.setProperty("--navbar-height", getNavbarHeight());
  }

  const navbarResizeObserver = new ResizeObserver((entries) => {
    entries.forEach(() => {
      setNavbarHeight();
    });
  });
  navbarResizeObserver.observe(navbar);
}
